module.exports = __webpack_public_path__ + "img/92ccb6f3a8b841bac2addd83d91cd9162.ecf5c8bf.png";